import { GridValidRowModel } from '@mui/x-data-grid-pro';
import { Union } from 'ts-toolbelt';

import { NULLISH_CELL_VALUE } from '../../DataGridCustom.types';
import { TsrctCaseCancellationReason } from '@/generated/gql/graphql';
import {
  NegotiationCaseProcessStatusUnion,
  NegotiationCaseTechnicalStatusUnion,
  NegotiationProcessStatusChip,
} from '~/components/NegotiationProcessStatusChip/NegotiationProcessStatusChip';

interface NegotiationProcessStatusChipCellProps<R extends GridValidRowModel = any> {
  processStatus?: Union.Nullable<NegotiationCaseProcessStatusUnion>;
  status?: Union.Nullable<NegotiationCaseTechnicalStatusUnion>;
  cancellationReason?: Union.Nullable<TsrctCaseCancellationReason | `${TsrctCaseCancellationReason}`>;
  cancellationReasonText?: Union.Nullable<string>;
  row: R;
}

export const NegotiationProcessStatusChipCell = <R extends GridValidRowModel = any>({
  processStatus,
  status,
  cancellationReason,
  cancellationReasonText,
}: NegotiationProcessStatusChipCellProps<R>) => {
  // div wrapper needed to display chip correctly
  return processStatus && status ? (
    <div>
      <NegotiationProcessStatusChip
        processStatus={processStatus}
        status={status}
        cancellationReason={cancellationReason}
        cancellationReasonText={cancellationReasonText}
      />
    </div>
  ) : (
    <>{NULLISH_CELL_VALUE}</>
  );
};
